import { BaseEditViewStore, StepperStore, BaasicDropdownStore } from 'core/stores';
import { FacilityOrderTemplateNewFlowPatientCreateForm } from 'application/facility-order-new-flow/forms';
import { FacilityOrderTemplateNewFlowCreateViewStore } from "application/facility-order-new-flow/stores";
import { FacilityOrderService, FacilityOrderTemplateService } from 'application/facility-order/services';
import { LocalPatientService } from 'application/patient/services';
import { EligibilityStatusService } from 'application/eligibility-status/services';
import { PatientService } from 'application/patient/services';
import { DoctorService } from 'application/import/services';
import { LookupService } from "common/services";
import { ModalParams } from 'core/models';
import { action, observable, runInAction } from 'mobx';
import moment from 'moment';
import _ from 'lodash';

class FacilityOrderTemplateNewFlowPatientCreateViewStore extends BaseEditViewStore {
	@observable accessor isCheckingForExistingPatient = false;
	@observable accessor isCheckingForExistingPatientOver = false;

	@observable accessor facilityOrderTemplateItems = [];
	@observable accessor facilityOrderTemplateTrachItems = [];

	@observable accessor eligibilityStatus = null;
	@observable accessor titleData;
	@observable accessor disabled = false;

	initialStepperItems = [{ label: "Personal Data", disabled: true, isValid: undefined, icon: "k-i-lock", fieldsForValidation: ["firstName", "lastName", "dateOfBirth"] },
	{ label: "Contact Info", disabled: true, isValid: undefined, icon: "k-i-track-changes-accept", fieldsForValidation: ["ssn", "contactPhone", "contactPostalCode"] },
	{ label: "Clinical Data", disabled: true, isValid: undefined, icon: "k-i-dollar", fieldsForValidation: ["height", "weight"] },
	{ label: "Template", disabled: true, isValid: undefined, icon: "k-i-dollar", fieldsForValidation: ["subCategoryId"] }];

	constructor(rootStore) {
        const facilityOrderId = rootStore.routerStore.routerState.params.id;

        super(rootStore, {
			name: 'facility-order-template-new-flow-patient-create',
			Form: FacilityOrderTemplateNewFlowPatientCreateForm,
			autoInit: false,
			actions: {
				create: async data => {
					const resource = {
						...data,
						orderingDoctorId: data.orderingDoctorId === "" ? 0 : data.orderingDoctorId,
						facilityOrderId: this.facilityOrderId,
						dateOfBirth: moment(data.dateOfBirth).format("YYYY-MM-DD hh:mm"),
						subCategoryId: undefined
					};

					return await this.patientService.createBrightreeAndLocalPatientAndInitializeTemplate(resource);
				},
				createTemplate: async (items, resource, facilityOrderId, patientId) => {
					let facilityOrderTemplateItems = items.filter(x => x.product);
					facilityOrderTemplateItems.forEach(i => delete i.id);

					resource.facilityOrderTemplateMissingDocuments = resource.facilityOrderTemplateMissingDocuments && resource.facilityOrderTemplateMissingDocuments.map(i => { return { missingDocumentId: i.id } });

					let request = {
						...resource,
						facilityOrderId: facilityOrderId,
						patientId: patientId,
						facilityOrderTemplateItems: facilityOrderTemplateItems,
					}

					const response = await this.facilityOrderTemplateService.createTemplateAndItemsNewFlow(request);
					return response.data;
				}
			},
			authorization: 'facilityOrderSection.create',
			FormClass: FacilityOrderTemplateNewFlowPatientCreateForm,
		});

        this.rootStore = rootStore;
        this.facilityOrderId = facilityOrderId;
        this.facilityOrderService = new FacilityOrderService(this.rootStore.application.baasic.apiClient);
        this.facilityOrderTemplateService = new FacilityOrderTemplateService(this.rootStore.application.baasic.apiClient);
        this.lookupService = new LookupService(this.rootStore.application.baasic.apiClient);
        this.patientService = new PatientService(this.rootStore.application.baasic.apiClient);
        this.doctorService = new DoctorService(rootStore.application.baasic.apiClient);
        this.eligibilityStatusService = new EligibilityStatusService(rootStore.application.baasic.apiClient);
        this.localPatientService = new LocalPatientService(this.rootStore.application.baasic.apiClient);

        this.existingPatientDataModal = new ModalParams({ onClose: null });
        this.createFacilityOrderTemplateNewPatientNewFlowModal = new ModalParams({ });

        this.contactRelationshipStore = new BaasicDropdownStore({
			textField: 'name',
			dataItemKey: 'name',
			filterable: true
		}, {
			fetchFunc: (term) => {
				let relationships = [{ id: 1, name: 'None' }, { id: 2, name: 'Child' }, { id: 3, name: 'Friend' }, { id: 4, name: 'Grandparent' }, { id: 5, name: 'Other' }, { id: 6, name: 'Parent' }, { id: 7, name: 'Self' }, { id: 8, name: 'Spouse' }];
				if (term) {
					return relationships.filter(r => r.name.toLowerCase().includes(term));
				}
				return relationships;
			}
		});

        this.stateStore = new BaasicDropdownStore({
			textField: 'name',
			dataItemKey: 'abrv',
			filterable: true
		}, {
			fetchFunc: async (term = "") => {
				await this.getStates();
				const stateData = this.states.filter((s) => s.name.toLowerCase().includes(term.toLowerCase()));

				return stateData;
			},
		});

        this.genderStore = new BaasicDropdownStore({
			textField: 'name',
			dataItemKey: 'name',
			filterable: true
		}, {
			fetchFunc: () => {
				return [{ id: 1, name: 'Male' }, { id: 2, name: 'Female' }];
			}
		});

        this.doctorStore = new BaasicDropdownStore({
			textField: 'orderingDoctor',
			dataItemKey: 'orderingDoctorId',
			filterable: true,
			returnObject: true
		}, {
			fetchFunc: async (term) => {
				const response = await this.doctorService.find({ searchQuery: term });

				_.extend(response.data,
					{
						item: _.map(response.data.item, (item => {
							return _.extend(
								item, {
								orderingDoctor: (item.name + " - " + item.npi),
								orderingDoctorId: item.id
							}
							);
						}))
					});
				return response.data.item;
			},
			onChange: (doctor) => {
				this.form.set({ orderingDoctor: doctor.orderingDoctor, orderingDoctorId: doctor.orderingDoctorId });
			}
		});

        this.eligibilityStatusStore = new BaasicDropdownStore({
			filterable: true,
		}, {
			fetchFunc: async (term) => {
				const response = await this.eligibilityStatusService.find({
					searchQuery: term,
					rpp: 50
				});
				return response.data.item;
			},
			onChange: () => {
				this.eligibilityStatus = this.eligibilityStatusStore.value && this.eligibilityStatusStore.value.name;
			}
		});

        this.initializeStepper();
        this.fetch([this.initialize()]);
    }

	@action
	async initializeStepper() {
		this.stepperStore = new StepperStore(
			{
				showIconIfValid: false,
				form: this.form,
				validatePreviousStep: true
			},
			this.initialStepperItems,
			true
		);
	}

	@action
	async initialize() {
		await this.setTitle();

		this.form.clear();

		this.form.observe({
			path: 'firstName',
			key: 'value',
			call: () => {
				this.stepperStore.calculateCurrentStepValidity();
			},
		});
		this.form.observe({
			path: 'lastName',
			key: 'value',
			call: () => {
				this.stepperStore.calculateCurrentStepValidity();
			},
		});
		this.form.observe({
			path: 'dateOfBirth',
			key: 'value',
			call: () => {
				this.stepperStore.calculateCurrentStepValidity();
			},
		});
		this.form.observe({
			path: 'ssn',
			key: 'value',
			call: () => {
				this.stepperStore.calculateCurrentStepValidity();
			},
		});
		this.form.observe({
			path: 'contactPostalCode',
			key: 'value',
			call: () => {
				this.stepperStore.calculateCurrentStepValidity();
			},
		});
		this.form.observe({
			path: 'contactPhone',
			key: 'value',
			call: () => {
				this.stepperStore.calculateCurrentStepValidity();
			},
		});
		this.form.observe({
			path: 'weight',
			key: 'value',
			call: () => {
				this.stepperStore.calculateCurrentStepValidity();
			},
		});
		this.form.observe({
			path: 'height',
			key: 'value',
			call: () => {
				this.stepperStore.calculateCurrentStepValidity();
			},
		});
		this.form.observe({
			path: 'subCategoryId',
			key: 'value',
			call: () => {
				this.stepperStore.calculateCurrentStepValidity();
			},
		});

		if (this.usIntakeStatus && this.usIntakeStatus.completedOn) {
			this.form.observe({
				path: 'eligibilityStatusId',
				key: 'value',
				call: () => {
					this.stepperStore.calculateCurrentStepValidity();
				},
			});
		}
		else {
			this.form.fields.get('eligibilityStatusId').set('rules', null);
		}

		const itemCategoryLookup = await this.lookupService.getLookups("ItemCategory");
		this.enteralItemCategoryId = _.find(itemCategoryLookup.itemCategory, s => { return s.abrv === 'enteral'; }).id;
	}

	async setTitle() {
		const facilityOrderResponse = await this.facilityOrderService.get(this.facilityOrderId, { embed: 'Facility,FacilityOrderStatuses' });
		this.facilityOrder = facilityOrderResponse.data;
		this.usIntakeStatus = facilityOrderResponse.data.facilityOrderStatuses.find(x => x.status && x.status.abrv === "us-intake");
		this.clinicalReviewStatus = facilityOrderResponse.data.facilityOrderStatuses.find(x => x.status && x.status.abrv === "clinical-review");
		this.titleData = `${facilityOrderResponse.data.facility.name} - Create New Patient`;
		this.rootStore.viewStore.setNavigationOptions({
			title: this.titleData,
			hideColon: true
		});

		this.facilityOrderTemplateNewFlowCreateViewStore = new FacilityOrderTemplateNewFlowCreateViewStore(this.rootStore, { form: this.form, facilityOrderTemplateItems: this.facilityOrderTemplateItems, facilityOrderTemplateTrachItems: this.facilityOrderTemplateTrachItems, facilityOrderId: this.facilityOrderId, facilityOrder: this.facilityOrder });
	}

	@action.bound
	async getStates() {
		const response = await this.lookupService.getLookups("State,NewFlowStatus,SubCategory");
		runInAction(() => {
			this.states = response.state;
			this.newFlowStatus = response.newFlowStatus;
			this.subCategories = response.subCategory;
		});
	}

	@action.bound
	async checkForExistingBrightreePatient() {
		const { firstName, lastName, dateOfBirth } = this.form.values();
		if (firstName === '' || lastName === '' || dateOfBirth === '') {
			this.rootStore.notificationStore.warning('Please enter all required fields.');
			return;
		}
		const dateParts = dateOfBirth.toString().split(' ');
		const yearPart = parseInt(dateParts[3]).toString();
		if (yearPart.length !== 4) {
			this.rootStore.notificationStore.warning('Please enter a valid value for Date Of Birth.');
			return;
		}

		this.isCheckingForExistingPatient = true;
		try {
			const params = {
				firstName,
				lastName,
				dateOfBirth: moment(dateOfBirth).format("YYYY-MM-DD hh:mm")
			}

			const localPatientResponse = await this.localPatientService.find({ ...params, fields: "Id" });
			if (localPatientResponse && localPatientResponse.data && localPatientResponse.data.item && localPatientResponse.data.item.some(x => x)) {
				let params = {
					pageSize: 1000,
					facilityOrderId: this.facilityOrderId,
					patientId: localPatientResponse.data.item[0].id,
					fields: "Id,ItemCategoryId",

				}
				const facilityOrderTemplateResponse = await this.facilityOrderTemplateService.find(params);
				if (facilityOrderTemplateResponse.data && facilityOrderTemplateResponse.data.item && facilityOrderTemplateResponse.data.item.some(x => x)) {
					if (!this.facilityOrder.isEnteralWeek || (this.facilityOrder.isEnteralWeek && facilityOrderTemplateResponse.data.item.some(x => x && x.itemCategoryId == this.enteralItemCategoryId))) {
						this.rootStore.notificationStore.error('This patient already exists in the facility order.');
						this.isCheckingForExistingPatient = false;
						return;
					}
					else{
						await this.createFacilityOrderTemplateNewPatientNewFlowModal.open({
							facilityOrderId: this.facilityOrder.id,
							patientId: localPatientResponse.data.item[0].id,
							patientKey: localPatientResponse.data.item[0].patientKey,
							patient: localPatientResponse.data.item[0],
							facilityOrder: this.facilityOrder,
						});
						this.isCheckingForExistingPatient = false;
						return;
					}
				}
			}

			const patientResponse = await this.patientService.findPatients(params);
			if (patientResponse.item && patientResponse.item.length > 0) {
				this.openExistingPatientDataModal(patientResponse.item);
			}
			else {
				this.isCheckingForExistingPatientOver = true;
				await this.stepperStore.goToNextStep();
				this.rootStore.notificationStore.warning('Searched patient doesn\'t exist in Brightree. Please fill out the rest of the form to create a new one.');
			}
		}
		catch (err) {
			this.rootStore.notificationStore.error('Error occured while trying to get brightree patient data.', err);
		}

		this.isCheckingForExistingPatient = false;
	}

	@action.bound
	openExistingPatientDataModal(patients) {
		this.existingPatientDataModal.open({
			patients: patients,
			facilityOrderId: this.facilityOrderId,
			isNewFlow: true,
			newFlowStatusId: _.find(this.newFlowStatus, s => { return s.abrv === 'new-order'; }).id,
			titleData: this.titleData,
			usIntakeStatus: this.usIntakeStatus,
			isEnteralWeek: this.facilityOrder.isEnteralWeek, 
			goBack: () => this.rootStore.routerStore.goBack()
		});
	}

	@action.bound
	async createResource(resource) {
		if (!this.actions.create) return;

		this.disabled = true;
		this.form.setFieldsDisabled(true);
		try {
			if (this.translationStore) {
				this.translationStore.applyMetadata(resource);
			}

			var result = await this.actions.create(resource);
			if (result && result.data && result.data.id) {
				try {
					if (this.facilityOrderTemplateTrachItems.some(i => i.product)) {
						const respiratorySubCategory = this.subCategories.find(x => x.abrv == 'Respiratory---trachs-supply');
						var response = await this.actions.createTemplate(this.facilityOrderTemplateTrachItems, { ...resource, subCategoryId: respiratorySubCategory.id }, this.facilityOrderId, result.data.id);
						_.extend(resource, { linkedTemplateId: response.id })
					}

					await this.actions.createTemplate(this.facilityOrderTemplateItems, resource, this.facilityOrderId, result.data.id);
				}
				catch (err) {
					this.disabled = false;
					this.form.setFieldsDisabled(false);
					this.rootStore.notificationStore.error('Error ocurred while trying to create patient and template. Please try adding this patient again.', err);
					this.goToFirstStep();
					return;
				}
			}
			this.disabled = false;
			this.form.setFieldsDisabled(false);
			this.rootStore.notificationStore.success('Successfully created patient and patient templates.');

			this.rootStore.routerStore.goBack();
		}
		catch (err) {
			this.disabled = false;
			this.form.setFieldsDisabled(false);
			this.rootStore.notificationStore.error('Error occured while trying to create patient and template.', err);
		}
	}

	@action.bound
	goToFirstStep() {
		this.facilityOrderTemplateItems = [];
		this.facilityOrderTemplateTrachItems = [];
		this.isCheckingForExistingPatientOver = false;

		this.contactRelationshipStore.setValue(null);
		this.stateStore.setValue(null);
		this.genderStore.setValue(null);
		this.doctorStore.setValue(null);
		this.eligibilityStatusStore.setValue(null);

		this.form.reset();
		this.form.clear();

		this.facilityOrderTemplateNewFlowCreateViewStore = new FacilityOrderTemplateNewFlowCreateViewStore(this.rootStore, { form: this.form, facilityOrderTemplateItems: this.facilityOrderTemplateItems, facilityOrderTemplateTrachItems: this.facilityOrderTemplateTrachItems, facilityOrderId: this.facilityOrderId, facilityOrder: this.facilityOrder  });
		this.stepperStore.goToStep(0);
		this.initializeStepper();
	}

	@action.bound
	async checkForSsn() {
		if (this.form.$("contactPostalCode").isValid && this.form.$("contactPhone").isValid && !this.form.$("ssn").value) {
			this.rootStore.modalStore.showConfirm(
				'The SSN field is empty. Do you want to proceed anyway?',
				async () => {
					this.goToNextStep();
				}
			);
		}
		else {
			this.goToNextStep();
		}
	}

	@action.bound
	goToNextStep() {
		if (this.stepperStore.currentStep === 1 && this.form.$("ssn").isValid && this.form.$("contactPostalCode").isValid && this.form.$("contactPhone").isValid) {
			this.stepperStore.goToNextStep();
		}
		else if (this.stepperStore.currentStep === 2 && this.form.$("height").isValid && this.form.$("weight").isValid && this.form.$("gender").value) {
			this.stepperStore.goToNextStep();
		}
		else {
			this.form.validate();
			this.form.showErrors();
		}
	}

	@action.bound
	goToPreviousStep() {
		if (this.stepperStore.currentStep === 2 && !this.form.$("gender").value) {
			this.form.validate();
			this.form.showErrors();
			return;
		}
		this.stepperStore.goToPreviousStep();
	}
}

export default FacilityOrderTemplateNewFlowPatientCreateViewStore;
